/**
 * Switching who is signed in is a CLEAN BREAK (Sigge 2026-10-07: "when I now
 * login as a consumer, and hit back I'm at the purchaser account and vice
 * versa. We need better separation").
 *
 * - Signing in or out leaves the page for a fresh one (`freshPage`): nothing
 *   the previous person loaded - their plan, viewers, titles - survives in
 *   memory, and the history entry is replaced rather than added.
 * - A page the browser restores from its back/forward cache is a snapshot of
 *   whoever was signed in when it was left; it is reloaded so it asks the
 *   server who is signed in NOW (`reloadOnBackCache`).
 *
 * A module of its own so tests can observe navigation without jsdom
 * performing it.
 */
export function freshPage(path: string): void {
  window.location.replace(path);
}

export function reloadOnBackCache(): () => void {
  const onShow = (e: PageTransitionEvent) => {
    if (e.persisted) window.location.reload();
  };
  window.addEventListener("pageshow", onShow);
  return () => window.removeEventListener("pageshow", onShow);
}

/** Where a person lands after signing in, by what they are. */
export function homeFor(kind: string | undefined, next: string | null): string {
  if (next) return next;
  return kind === "purchaser" ? "/plan" : "/";
}
